import { RolesPermissionType } from './../../../../../../apps/portal-front-end/src/app/roles-permissions-store/roles-permissions.state';
import { delay, map, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Observable, interval } from 'rxjs';
import { Injectable, Inject } from '@angular/core';
import { User, OrganisationId, UserId, Organisation, NewUserDetails, PasswordResetToken, InvitationConfirmation } from '@portal-front-end/models';
import { PORTAL_API_ROOT_URL } from '../constants';
import { API_SERVER_TOKEN } from '../api-server-token';
import { Update } from '@ngrx/entity';

import { environment } from '../../../../../../apps/portal-front-end/src/environments/environment';

@Injectable({ providedIn: 'root' })

export class UsersApiService {
    constructor(
        private readonly http: HttpClient,
        @Inject(API_SERVER_TOKEN) private apiServer: string
    ) { }

    private readonly USER_API_URL = `${this.apiServer}/users`;

    // Who Am I
    getLoggedInUserDetails(): Observable<User> {
        return this.http.get<User>(`${this.USER_API_URL}/whoami`);
    }

    createUserFromInvitation(invitationId: string, userDetails: NewUserDetails): Observable<PasswordResetToken> {
        return this.http.post<PasswordResetToken>(`${this.USER_API_URL}/from-invite/${invitationId}`, userDetails);
    }

    // User organisations
    getUsersByOrganisation(organisationId: OrganisationId): Observable<User[]> {
        return this.http.get<User[]>(`${this.apiServer}/organisations/${organisationId}/users`);
    }

    updateUserByOrganisation(organisationId: OrganisationId, user: Update<User>): Observable<User> {
        return this.http.put<User>(`${this.apiServer}/organisations/${organisationId}/users/${user.changes.userId}`, user.changes);
    }

    deleteUserFromOrganisation(organisationId: OrganisationId, userId: string): Observable<string | number> {
        return this.http.delete<string>(`${this.apiServer}/organisations/${organisationId}/users/${userId}`)
            .pipe(map(() => userId))
    }

    // User Permissions
    getUserPermission(organisationId: OrganisationId): Observable<RolesPermissionType> {
        return this.http.get<RolesPermissionType>(`${this.USER_API_URL}/permissions`, {
            params: {
                organisationId
            }
        });
    }

    acceptInvitation(invitationId: string): Observable<InvitationConfirmation> {
        return this.http.post<InvitationConfirmation>(`${this.USER_API_URL}/accept/${invitationId}`, null);
    }

}
